export const BARCODE_POOL_PROVIDER_CODES = Object.freeze(['Ptt', 'PttAbroad']);

export const MAX_RANGE_SIZE = 5000000;

export const BIG_RANGE_THRESHOLD = 500000;

export const BARCODE_TYPE_PREFIX_MAP = Object.freeze({
  LE: 'small',
  CE: 'large'
});

export const BARCODE_STATE_VARIANT = Object.freeze({
  available: 'success',
  reserved: 'warning',
  used: 'primary',
  skipped: 'secondary'
});

export const BARCODE_STATE_ICON = Object.freeze({
  available: 'CircleIcon',
  reserved: 'LockIcon',
  used: 'CheckCircleIcon',
  skipped: 'SlashIcon'
});

export const ALERT_LEVEL_VARIANT = Object.freeze({
  ok: 'success',
  info: 'info',
  warning: 'warning',
  high: 'warning',
  critical: 'danger',
  exhausted: 'warning',
  completed: 'dark'
});

export const ALERT_THRESHOLDS = Object.freeze({
  critical: 5,
  high: 10,
  warning: 25,
  info: 50
});

export const BARCODE_REGEX = /^\d{12}$|^[A-Z]{2}\d{9}TR$/;

export function inferBarcodeType(barcode) {
  if (!barcode || typeof barcode !== 'string') return null;
  const match = barcode.match(/^([A-Z]{2})\d{9}TR$/);
  if (!match) return null;
  return BARCODE_TYPE_PREFIX_MAP[match[1]] || null;
}

export function getBarcodeNumericPart(barcode) {
  if (!barcode || typeof barcode !== 'string') return null;
  if (/^\d{12}$/.test(barcode)) return barcode;
  const match = barcode.match(/^[A-Z]{2}(\d{8})\dTR$/);
  return match ? match[1] : null;
}

export function calculateRangeSize(start, end) {
  const startNum = getBarcodeNumericPart(start);
  const endNum = getBarcodeNumericPart(end);
  if (!startNum || !endNum) return 0;
  const diff = Number(endNum) - Number(startNum) + 1;
  return diff > 0 ? diff : 0;
}

export function computeAlertLevel(counts) {
  if (!counts || !counts.total_count) return 'exhausted';

  const available = counts.available_count || 0;
  const reserved = counts.reserved_count || 0;

  if (available === 0 && reserved === 0) return 'completed';

  const pct = (available / counts.total_count) * 100;

  if (pct === 0) return 'exhausted';
  if (pct <= ALERT_THRESHOLDS.critical) return 'critical';
  if (pct <= ALERT_THRESHOLDS.high) return 'high';
  if (pct <= ALERT_THRESHOLDS.warning) return 'warning';
  if (pct <= ALERT_THRESHOLDS.info) return 'info';
  return 'ok';
}

export function segmentPct(counts, field) {
  if (!counts || !counts.total_count) return 0;
  return ((counts[field] || 0) / counts.total_count) * 100;
}

export function availablePct(counts) {
  return Math.round(segmentPct(counts, 'available_count'));
}

export function getAlertVariant(alertLevel) {
  return ALERT_LEVEL_VARIANT[alertLevel] || 'secondary';
}
